/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Create_Company_User_Add_To_Company_FailedInputs */

const en_admin_create_company_user_add_to_company_failed = /** @type {(inputs: Admin_Create_Company_User_Add_To_Company_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Failed to add user to company.`)
};

const de_admin_create_company_user_add_to_company_failed = /** @type {(inputs: Admin_Create_Company_User_Add_To_Company_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Benutzer konnte dem Unternehmen nicht hinzugefügt werden.`)
};

/**
* | output |
* | --- |
* | "Failed to add user to company." |
*
* @param {Admin_Create_Company_User_Add_To_Company_FailedInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const admin_create_company_user_add_to_company_failed = /** @type {((inputs?: Admin_Create_Company_User_Add_To_Company_FailedInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Create_Company_User_Add_To_Company_FailedInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_admin_create_company_user_add_to_company_failed(inputs)
	return en_admin_create_company_user_add_to_company_failed(inputs)
});